import React from "react";
import "./Loader.css";

const Loader = ({ message }) => {
  const [dots, setDots] = React.useState("");

  React.useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => (prev.length >= 3 ? "" : prev + "."));
    }, 200);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loader-overlay">
      <div className="loader-container">
        <div className="spinner" />
        <p>
          {message}
          <span className="dots">
            {dots}
          </span>
        </p>
      </div>
    </div>
  );
};

export default Loader;
